/* PARALIA · ficha de producto (sections/pa-product, pa-product-together, pa-product-related).
   Usa window.PA (assets/paralia.js). Sin librerías.
   Evento propio en document: pa:pdp:variant  detail: { sectionId, variant, label }  cuando cambia la variante. */
(() => {
  if (window.PaProduct) return;

  const fm = cents => (window.PA ? PA.formatMoney(cents) : '$' + (cents / 100).toFixed(2));
  const SIZE_NAMES = ['size', 'talla', 'tallas', 'tamaño', 'tamano'];
  const COLOR_NAMES = ['color', 'colour'];

  function shortSize(v, on) {
    if (!on) return v;
    const k = String(v).trim().toLowerCase();
    return ({ 'extra small': 'XS', 'x-small': 'XS', xsmall: 'XS', small: 'S', medium: 'M', large: 'L', 'extra large': 'XL', 'x-large': 'XL', xlarge: 'XL' })[k] || v;
  }

  function variantLabel(variant, optionNames, short) {
    if (!variant || optionNames.length === 1 && variant.title === 'Default Title') return '';
    let color = '', size = '';
    const rest = [];
    optionNames.forEach((name, i) => {
      const n = name.trim().toLowerCase(), val = variant.options[i];
      if (COLOR_NAMES.includes(n)) color = val;
      else if (SIZE_NAMES.includes(n)) size = shortSize(val, short);
      else rest.push(val);
    });
    return [color, size, ...rest].filter(Boolean).join(' / ');
  }

  function priceHTML(v, labels) {
    if (v.compare_at_price && v.compare_at_price > v.price) {
      return `<span class="pa-price" data-pa-price><s class="pa-price__compare"><span class="pa-visually-hidden">${labels.regular}</span>${fm(v.compare_at_price)}</s><span class="pa-price__sale"><span class="pa-visually-hidden">${labels.sale}</span>${fm(v.price)}</span></span>`;
    }
    return `<span class="pa-price" data-pa-price><span class="pa-price__regular">${fm(v.price)}</span></span>`;
  }

  /* ---------------- ficha principal ---------------- */
  function initMain(root) {
    if (root.dataset.paReady) return;
    root.dataset.paReady = '1';
    const json = root.querySelector('[data-pa-pdp-json]');
    if (!json) return;
    const data = JSON.parse(json.textContent);
    const sectionId = root.dataset.sectionId;
    const variants = data.variants;
    const names = data.options;
    const optionEls = [...root.querySelectorAll('[data-pa-pdp-option]')];
    const idInput = root.querySelector('[data-pa-pdp-id]');
    const form = root.querySelector('[data-pa-pdp-form]');
    const addBtn = root.querySelector('[data-pa-pdp-add]');
    const qtyInput = root.querySelector('[data-pa-pdp-qty-input]');
    const promo = root.querySelector('[data-pa-pdp-promo]');
    const sticky = root.querySelector('[data-pa-pdp-sticky]');

    let current = variants.find(v => String(v.id) === String(idInput && idInput.value)) || variants[0];
    let cartTotal = promo ? Number(promo.dataset.cartTotal || 0) : 0;

    /* ----- galería ----- */
    const slidesBox = root.querySelector('[data-pa-pdp-slides]');
    const slides = [...root.querySelectorAll('[data-pa-pdp-slide]')];
    const thumbs = [...root.querySelectorAll('[data-pa-pdp-thumb]')];
    const counter = root.querySelector('[data-pa-pdp-count]');
    const isDesk = () => window.matchMedia('(min-width: 990px)').matches;

    function setActive(mediaId, scroll) {
      const slide = slides.find(s => s.dataset.mediaId === String(mediaId));
      if (!slide) return;
      slides.forEach(s => s.classList.toggle('is-active', s === slide));
      thumbs.forEach(t => {
        const on = t.dataset.mediaId === String(mediaId);
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      const img = slide.querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
      if (scroll && slidesBox && !isDesk()) {
        slidesBox.scrollTo({ left: slide.offsetLeft - slidesBox.offsetLeft, behavior: 'smooth' });
      }
      if (counter) counter.textContent = `${Number(slide.dataset.index) + 1} / ${slides.length}`;
    }
    thumbs.forEach(t => t.addEventListener('click', () => setActive(t.dataset.mediaId, false)));
    if (slidesBox && counter) {
      let raf;
      slidesBox.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          if (isDesk() || !slides.length) return;
          const w = slides[0].getBoundingClientRect().width + 4;
          let i = Math.round(slidesBox.scrollLeft / w);
          if (slidesBox.scrollLeft + slidesBox.clientWidth >= slidesBox.scrollWidth - 2) i = slides.length - 1;
          counter.textContent = `${Math.min(i, slides.length - 1) + 1} / ${slides.length}`;
        });
      }, { passive: true });
    }

    /* ----- opciones ----- */
    /* Los selectores se pintan color → talla → otros, pero el arreglo va en el orden de opciones de Shopify. */
    const selected = () => {
      const sel = names.map(() => null);
      optionEls.forEach(el => {
        const c = el.querySelector('input:checked');
        sel[Number(el.dataset.paPdpOption)] = c ? c.value : null;
      });
      return sel;
    };

    function markAvailability(sel) {
      optionEls.forEach(el => {
        const i = Number(el.dataset.paPdpOption);
        el.querySelectorAll('input').forEach(input => {
          const ok = variants.some(v => v.available && v.options[i] === input.value && sel.every((s, j) => j === i || s === null || v.options[j] === s));
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
        const valueEl = el.querySelector('[data-pa-pdp-opt-value]');
        if (valueEl && sel[i] !== null) valueEl.textContent = el.dataset.kind === 'size' ? shortSize(sel[i], data.shortSizes) : sel[i];
      });
    }

    function buttonLabel(v) {
      if (!addBtn) return;
      const txt = addBtn.querySelector('[data-pa-pdp-add-text]');
      let label;
      if (!v) label = addBtn.dataset.labelUnavailable;
      else if (!v.available) label = addBtn.dataset.labelSoldout;
      else label = addBtn.dataset.labelAdd + (addBtn.dataset.showPrice === 'true' ? ' · ' + fm(v.price) : '');
      txt.textContent = label;
      addBtn.disabled = !v || !v.available;
    }

    function updatePromo() {
      if (!promo || !current) return;
      const threshold = Number(promo.dataset.threshold || 0);
      const qty = Math.max(1, Number(qtyInput && qtyInput.value) || 1);
      const missing = threshold - cartTotal - current.price * qty;
      const miss = promo.querySelector('[data-pa-pdp-promo-missing]');
      const reach = promo.querySelector('[data-pa-pdp-promo-reached]');
      const amount = promo.querySelector('[data-pa-pdp-promo-amount]');
      if (amount && missing > 0) amount.textContent = fm(missing);
      if (miss) miss.hidden = missing <= 0;
      if (reach) reach.hidden = missing > 0;
    }

    function render(v, prevMedia) {
      buttonLabel(v);
      const stickyBtn = root.querySelector('[data-pa-pdp-sticky-add]');
      if (stickyBtn) stickyBtn.disabled = !v || !v.available;
      if (!v) return;
      if (idInput) idInput.value = v.id;
      root.querySelectorAll('[data-pa-pdp-price-slot]').forEach(slot => { slot.innerHTML = priceHTML(v, data.priceLabels); });
      const badge = root.querySelector('[data-pa-pdp-badge]');
      if (badge) {
        const pct = v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        badge.hidden = pct === 0;
        const n = badge.querySelector('[data-pa-pdp-pct]');
        if (n) n.textContent = pct;
      }
      const label = variantLabel(v, names, data.shortSizes);
      root.querySelectorAll('[data-pa-pdp-variant-label]').forEach(el => { el.textContent = label; });
      if (v.featured_media) {
        if (String(v.featured_media.id) !== String(prevMedia)) setActive(v.featured_media.id, true);
        const sImg = root.querySelector('.pa-pdp-sticky__img');
        const src = v.featured_media.preview_image && v.featured_media.preview_image.src;
        if (sImg && src) { sImg.removeAttribute('srcset'); sImg.src = src + (src.includes('?') ? '&' : '?') + 'width=120'; }
      }
      updatePromo();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      document.dispatchEvent(new CustomEvent('pa:pdp:variant', { detail: { sectionId, productId: data.productId, variant: v, label, priceLabels: data.priceLabels } }));
    }

    optionEls.forEach(el => el.addEventListener('change', () => {
      const sel = selected();
      const prevMedia = current && current.featured_media ? current.featured_media.id : null;
      const v = variants.find(x => x.options.every((o, i) => o === sel[i])) || null;
      markAvailability(sel);
      if (v) current = v;
      render(v, prevMedia);
    }));
    if (optionEls.length) markAvailability(selected());

    /* ----- cantidad ----- */
    root.querySelectorAll('[data-pa-pdp-qty]').forEach(b => b.addEventListener('click', () => {
      if (!qtyInput) return;
      const n = Math.min(99, Math.max(1, (Number(qtyInput.value) || 1) + Number(b.dataset.paPdpQty)));
      qtyInput.value = n;
      updatePromo();
    }));
    if (qtyInput) qtyInput.addEventListener('change', () => {
      qtyInput.value = Math.min(99, Math.max(1, Math.round(Number(qtyInput.value) || 1)));
      updatePromo();
    });

    /* ----- agregar ----- */
    async function add(btn) {
      if (!current || !current.available || !window.PA) return;
      const err = root.querySelector('[data-pa-form-error]');
      if (err) err.hidden = true;
      btn.classList.add('is-loading');
      try {
        await PA.add({ id: Number(idInput ? idInput.value : current.id), quantity: Math.max(1, Number(qtyInput && qtyInput.value) || 1) });
      } catch (e) {
        if (err) { err.textContent = e.message; err.hidden = false; }
      } finally {
        btn.classList.remove('is-loading');
      }
    }
    if (form) form.addEventListener('submit', e => { e.preventDefault(); add(addBtn); });

    /* ----- aviso de promoción ----- */
    if (promo) {
      document.addEventListener('pa:cart:updated', e => {
        if (e.detail && e.detail.cart) { cartTotal = e.detail.cart.total_price; updatePromo(); }
      });
      updatePromo();
    }

    /* ----- PDP-11 barra fija ----- */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      const stickyBtn = sticky.querySelector('[data-pa-pdp-sticky-add]');
      stickyBtn.addEventListener('click', () => {
        if (current && current.available) add(stickyBtn);
        else addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      const show = on => {
        sticky.classList.toggle('is-visible', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
        document.body.classList.toggle('pa-has-sticky', on);
      };
      new IntersectionObserver(([entry]) => {
        show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(addBtn);
    }

    /* ----- guía de tallas: pestañas en celular ----- */
    const guide = root.querySelector('.pa-pdp-guide');
    if (guide) {
      const tabs = [...guide.querySelectorAll('[data-pa-guide-tab]')];
      const select = tab => {
        guide.dataset.group = tab.dataset.paGuideTab;
        tabs.forEach(t => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', e => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(next); next.focus();
        });
      });
    }
  }

  /* ---------------- PDP-13 Se llevan juntos ---------------- */
  function initTogether(box) {
    if (box.dataset.paReady) return;
    box.dataset.paReady = '1';
    const slot = document.querySelector('[data-pa-together-slot]');
    if (slot && !slot.contains(box)) slot.appendChild(box);

    const limit = Number(box.dataset.limit || 2);
    const others = box.querySelector('[data-pa-tg-others]');
    const current = box.querySelector('[data-pa-tg-current]');
    const btn = box.querySelector('[data-pa-tg-add]');
    const err = box.querySelector('[data-pa-tg-error]');
    const productId = current ? current.dataset.productId : null;

    function trim() {
      let n = 0;
      others.querySelectorAll('[data-pa-tg-row]').forEach(r => {
        if (r.dataset.productId === productId || n >= limit) { r.remove(); return; }
        n++;
      });
      box.hidden = n === 0;
    }

    function totals() {
      let total = 0, compare = 0, count = 0;
      box.querySelectorAll('[data-pa-tg-row]').forEach(r => {
        const c = r.querySelector('[data-pa-tg-check]');
        if (!c || !c.checked || c.disabled) return;
        total += Number(r.dataset.price); compare += Number(r.dataset.compare); count++;
      });
      const t = box.querySelector('[data-pa-tg-total]'), s = box.querySelector('[data-pa-tg-compare]');
      if (t) t.textContent = fm(total);
      if (s) { s.textContent = compare > total ? fm(compare) : ''; s.hidden = !(compare > total); }
      if (btn) {
        btn.textContent = count > 1 ? box.dataset.labelMany.replace('[n]', count) : box.dataset.labelOne;
        btn.disabled = count === 0;
      }
    }

    box.addEventListener('change', e => { if (e.target.matches('[data-pa-tg-check]')) totals(); });
    if (btn) btn.addEventListener('click', async () => {
      const items = [];
      box.querySelectorAll('[data-pa-tg-row]').forEach(r => {
        const c = r.querySelector('[data-pa-tg-check]');
        if (c && c.checked && !c.disabled) items.push({ id: Number(r.dataset.variantId), quantity: 1 });
      });
      if (!items.length || !window.PA) return;
      if (err) err.hidden = true;
      btn.classList.add('is-loading');
      try { await PA.add(items); } catch (e) { if (err) { err.textContent = e.message; err.hidden = false; } }
      finally { btn.classList.remove('is-loading'); }
    });

    document.addEventListener('pa:pdp:variant', e => {
      const d = e.detail;
      if (!current || String(d.productId) !== productId) return;
      const v = d.variant;
      current.dataset.variantId = v.id;
      current.dataset.price = v.price;
      current.dataset.compare = v.compare_at_price || v.price;
      const c = current.querySelector('[data-pa-tg-check]');
      if (c) { c.disabled = !v.available; if (!v.available) c.checked = false; else if (current.dataset.unavailable !== undefined) c.checked = true; }
      if (v.available) delete current.dataset.unavailable; else current.dataset.unavailable = '';
      const l = current.querySelector('[data-pa-pdp-variant-label]');
      if (l) l.textContent = d.label;
      const p = current.querySelector('[data-pa-pdp-price-slot]');
      if (p) { p.innerHTML = priceHTML(v, d.priceLabels); const pr = p.querySelector('.pa-price'); if (pr) pr.classList.add('pa-tg__price'); }
      const img = current.querySelector('.pa-tg__cimg');
      const src = v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src;
      if (img && src) { img.removeAttribute('srcset'); img.src = src + (src.includes('?') ? '&' : '?') + 'width=120'; }
      totals();
    });

    trim();
    totals();
    if (box.dataset.url) {
      fetch(box.dataset.url).then(r => r.text()).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-pa-tg-others]');
        if (fresh && fresh.querySelector('[data-pa-tg-row]')) {
          others.innerHTML = fresh.innerHTML;
          trim();
          totals();
        }
      }).catch(() => {});
    }
  }

  /* ---------------- PDP-12 relacionados ---------------- */
  function initRelated(sec) {
    if (sec.dataset.paReady || !sec.dataset.url) return;
    sec.dataset.paReady = '1';
    const load = () => fetch(sec.dataset.url).then(r => r.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = doc.querySelector('[data-pa-related-grid]');
      if (grid && grid.children.length) {
        sec.querySelector('[data-pa-related-grid]').innerHTML = grid.innerHTML;
        sec.hidden = false;
      }
    }).catch(() => {});
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
      io.observe(sec.hidden ? sec.parentElement : sec);
    } else load();
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-pa-pdp]').forEach(initMain);
    scope.querySelectorAll('[data-pa-together]').forEach(initTogether);
    scope.querySelectorAll('[data-pa-related]').forEach(initRelated);
  }

  window.PaProduct = { initAll, variantLabel, shortSize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();
